// Map Supabase rows (snake_case) to the shapes the React components expect.

export function rowToPosition(r) {
  return {
    id: r.id,
    mode: r.mode,
    tokenAddress: r.token_address,
    pairAddress: r.pair_address,
    tokenName: r.token_name,
    tokenSymbol: r.token_symbol,
    dexUrl: r.dex_url,
    entryPrice: r.entry_price,
    currentPrice: r.current_price,
    highestPrice: r.highest_price,
    limitPrice: r.limit_price,
    limitDirection: r.limit_direction,
    hardStop: r.hard_stop,
    takeProfit: r.take_profit,
    trailingStop: r.trailing_stop,
    tpTiers: r.tp_tiers,
    status: r.status,
    sellReason: r.sell_reason,
    amount: r.amount,
    initialAmount: r.initial_amount,
    costSol: r.cost_sol,
    realizedSol: r.realized_sol,
    tokenBalanceRaw: r.token_balance_raw,
    txids: r.txids || [],
    botTriggered: r.bot_triggered,
    error: r.error,
    priorityFee: r.priority_fee,
    slippageBps: r.slippage_bps,
    exitPrice: r.exit_price,
    boughtAt: r.bought_at,
    closedAt: r.closed_at,
    strategy: r.strategy ?? null,
    timeframe: r.timeframe ?? null,
    timestamp: r.created_at ? new Date(r.created_at).getTime() : Date.now(),
    updatedAt: r.updated_at
  };
}

export function rowToSettings(r) {
  return {
    rpcEndpoint: r.rpc_endpoint,
    rpcBackupEndpoint: r.rpc_backup_endpoint || '',
    rpcWsEndpoint: r.rpc_ws_endpoint,
    jupiterApiKey: r.jupiter_api_key,
    coingeckoApiKey: r.coingecko_api_key,
    birdeyeApiKey: r.birdeye_api_key,
    birdeyeEnabled: r.birdeye_enabled,
    slippage: r.slippage,
    priorityFee: r.priority_fee,
    maxPriceImpactPct: r.max_price_impact_pct,
    minLiquidityUsd: r.min_liquidity_usd,
    defaultBuyAmount: r.default_buy_amount,
    hardStop: r.hard_stop,
    hardStopEnabled: r.hard_stop_enabled,
    trailingStop: r.trailing_stop,
    trailingStopEnabled: r.trailing_stop_enabled,
    takeProfit: r.take_profit,
    takeProfitEnabled: r.take_profit_enabled,
    botTimeframe: r.bot_timeframe,
    botActive: r.bot_active,
    tradingMode: r.trading_mode,
    strategy: r.strategy || 'confluence',
    signalQualityEnabled: r.signal_quality_enabled !== false,
    reentryCooldownEnabled: r.reentry_cooldown_enabled !== false,
    antiRugEnabled: r.anti_rug_enabled !== false,
    botScheduleEnabled: r.bot_schedule_enabled === true,
    botScheduleStart: r.bot_schedule_start || '00:00',
    botScheduleEnd: r.bot_schedule_end || '00:00',
    botScheduleDays: r.bot_schedule_days || [0, 1, 2, 3, 4, 5, 6],
    breakevenArmPct: r.breakeven_arm_pct || '0',
    marketTideEnabled: r.market_tide_enabled === true,
    marketTideMin: r.market_tide_min || '0.4',
    tpTiers: r.tp_tiers || []
  };
}

export function rowToBotEvent(r) {
  return {
    id: r.id,
    createdAt: r.created_at,
    kind: r.kind,
    tokenAddress: r.token_address,
    tokenSymbol: r.token_symbol,
    strategy: r.strategy ?? null,
    timeframe: r.timeframe ?? null,
    reason: r.reason ?? null
  };
}

export function rowToWatch(r) {
  return {
    address: r.address,
    pairAddress: r.pair_address,
    symbol: r.symbol,
    name: r.name,
    dexUrl: r.dex_url,
    strategy: r.strategy ?? null,
    timeframe: r.timeframe ?? null
  };
}
